
import { ResponsiveContainer, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { useOwnerCurrency } from "@/hooks/useOwnerCurrency";

interface TransactionAmountLineChartProps {
  transactions: any[];
}

export const TransactionAmountLineChart = ({ transactions }: TransactionAmountLineChartProps) => {
  const { data: currency } = useOwnerCurrency();

  const transactionsByDate = transactions.reduce((acc: any, transaction) => {
    const date = format(new Date(transaction.created_at), 'P', { locale: fr });
    if (!acc[date]) {
      acc[date] = {
        date,
        montant: 0,
      };
    }
    acc[date].montant += transaction.total_amount;
    return acc;
  }, {});

  const lineChartData = Object.values(transactionsByDate);

  const formatCurrency = (value: number) => {
    return `${value.toLocaleString()} ${currency || 'GNF'}`;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={lineChartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis tickFormatter={(value) => `${value.toLocaleString()} ${currency || 'GNF'}`} />
        <Tooltip formatter={(value: any) => formatCurrency(value)} />
        <Legend />
        <Line
          type="monotone"
          dataKey="montant"
          stroke="#3b82f6"
          name="Montant total"
          strokeWidth={2}
          dot={{ r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
